import { FC, ReactNode } from "react";
import { StoryElement } from "../storyelements-management/story-element";
import { DateHeader } from "./date-header";

export interface GenericStoryElementComponentProps{
    storyElement: StoryElement,
    updateListFromServer: (() => void) | null,
    handleEditClicked: ((storyElement: any) => void) | null
}

const GenericStoryElementCompoment:FC<GenericStoryElementComponentProps> = () => {
    return <></>
};

interface StorylineElementListProps{
    storyElements: StoryElement[],
    updateListFromServer: (() => void) | null,
    Component: typeof GenericStoryElementCompoment,
    handleEditClicked: ((storyElement) => void) | null
}

export const GenericStorylineElementsList: FC<StorylineElementListProps> = ({ storyElements, Component, updateListFromServer, handleEditClicked }) => {
    return(
        <>
            {
                storyElements.map((storyElement, index) => {
                    const dateString = storyElement.timestampFormatted;
                    const prevDateString = index != 0 ? storyElements[index - 1].timestampFormatted : "";
                    return (
                        <>
                            <DateHeader prevDateString={prevDateString} dateString={dateString}/>
                            <Component storyElement={storyElement} updateListFromServer={updateListFromServer} handleEditClicked={handleEditClicked}/>
                        </>
                    );
                })
            }
        </>
    )
}
